/* =========================================================================
   omes-media.js — smart fit for square product photos.
   Liquid (snippets/omes-fit-class.liquid) marks square photos with
   `omes-fit-check`. For each one, a 24px copy is read from the Shopify CDN
   (a few hundred bytes, CORS-enabled) and its border is measured:
     plain, light border (mean ≥ 195, spread ≤ 28) → packshot → `omes-fit`
       (shown whole in the 3:4 card, assets/omes-media.css)
     anything else (a model, a décor, a dark set) → left as is, fills the frame.
   Results are cached per image for the session. Exposed as
   window.omesFitCheck(img) for markup drawn by scripts (quick view).
   ========================================================================= */
(function () {
  'use strict';
  if (window.omesFitCheck) return;

  var MIN_MEAN = 195, MAX_SD = 28, SIZE = 24;
  var KEY = 'omes-fit:';

  function tinyUrl(src) {
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + SIZE);
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + SIZE;
  }
  function cacheKey(src) { return KEY + src.split('?')[0].replace(/^https?:/, ''); }
  function readCache(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function writeCache(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function isPackshot(data) {
    var px = [], i, o, a, b;
    var edges = function (x, y) { o = (y * SIZE + x) * 4; px.push(0.299 * data[o] + 0.587 * data[o + 1] + 0.114 * data[o + 2]); };
    for (i = 0; i < SIZE; i++) { edges(i, 0); edges(i, SIZE - 1); edges(0, i); edges(SIZE - 1, i); }
    var sum = 0; for (i = 0; i < px.length; i++) sum += px[i];
    var mean = sum / px.length, v = 0;
    for (i = 0; i < px.length; i++) { a = px[i] - mean; v += a * a; }
    b = Math.sqrt(v / px.length);
    return mean >= MIN_MEAN && b <= MAX_SD;
  }

  function apply(img, packshot) {
    img.classList.toggle('omes-fit', packshot);
    img.classList.remove('omes-fit-check');
  }

  function check(img, done) {
    done = done || function () {};
    if (!img || img.dataset.omesFitDone) { done(); return; }
    img.dataset.omesFitDone = '1';
    var src = img.currentSrc || img.getAttribute('src') || ((img.getAttribute('srcset') || '').split(' ')[0]);
    var url = tinyUrl(src);
    if (!url || !window.fetch || !window.createImageBitmap) { done(); return; }
    var k = cacheKey(url), hit = readCache(k);
    if (hit !== null) { apply(img, hit === '1'); done(); return; }
    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
      .then(function (blob) { return createImageBitmap(blob); })
      .then(function (bm) {
        var c = document.createElement('canvas'); c.width = c.height = SIZE;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(bm, 0, 0, SIZE, SIZE);
        var p = isPackshot(x.getImageData(0, 0, SIZE, SIZE).data);
        writeCache(k, p ? '1' : '0');
        apply(img, p);
      })
      .catch(function () { /* network / decode issue: keep filling the frame */ })
      .then(done, done);
  }
  window.omesFitCheck = check;

  /* Every square photo on the page is checked, four at a time — not only the
     ones in view: cards in horizontal rails never scroll into the viewport
     vertically, so an IntersectionObserver left them unchecked. */
  var queue = [], running = 0, MAX = 4;
  function pump() {
    while (running < MAX && queue.length) {
      var img = queue.shift();
      running++;
      Promise.resolve(check(img, function () { running--; pump(); }));
    }
  }
  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('img.omes-fit-check') : []).forEach(function (img) {
      if (img.dataset.omesFitDone || img.dataset.omesFitSeen) return;
      img.dataset.omesFitSeen = '1';
      queue.push(img);
    });
    pump();
  }

  function start() {
    scan(document);
    /* Cards added later: filters, infinite scroll, product rails, drawers. */
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('img.omes-fit-check')) scan(n.parentNode); else scan(n); } }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
